import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MbscCalendarOptions, MbscRangeOptions } from '@mobiscroll/angular';
import { DateUtil, IFormFieldValidation } from '@nibtravel/shared/util/models';
import { format } from 'date-fns';

import { DatePickerType } from './models/date-picker-type';
import { defaultPickerConfig } from './models/mobiscroll';
import { DatePicker } from '@nibtravel/shared/util/e2e';
import { ValidationLabelMap } from '..';

@Component({
  selector: 'nibtravel-date-picker',
  templateUrl: './date-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatePickerComponent implements OnInit {
  @HostBinding('id') id = 'date-picker-host';
  @HostBinding('class') klass = 'date-picker-host';

  @Input() type!: DatePickerType;
  @Input() labels!: string | string[];
  @Input() placeholder!: string | string[];
  @Input() formGroup!: FormGroup;
  @Input() controlName!: string | string[];
  @Input() validations!: Array<IFormFieldValidation[]> | IFormFieldValidation[];
  @Input() e2eId: string | null = null;
  @Input() validationLabel!: ValidationLabelMap | string;
  @Input() startDatePlaceHolder = '';
  @Input() departureDatePlaceHolder = '';

  @ViewChild('mbsc') mbscInstance: any;
  private pickerSetting!: MbscRangeOptions | MbscCalendarOptions;
  @Input()
  set settings(value: MbscRangeOptions | MbscCalendarOptions) {
    if (value) {
      this.pickerSetting = {
        ...this.pickerSetting,
        ...value,
      };
    }
  }

  get settings(): MbscRangeOptions | MbscCalendarOptions {
    return this.pickerSetting;
  }

  @Output() startDateUpdated = new EventEmitter();
  @Output() endDateUpdated = new EventEmitter();

  supportedType = DatePickerType;
  internalE2eId = DatePicker;

  ngOnInit(): void {
    this.initDatePicker();
  }

  onFocus(selectedInput: string, ref: any): void {
    ref.instance.setActiveDate(selectedInput);
    ref.instance.show();
  }

  private initDatePicker() {
    this.settings = {
      ...defaultPickerConfig,
      onSet: (event: any, inst: any) => {
        let startDate;
        let endDate;

        switch (this.type) {
          case DatePickerType.Range:
            // eslint-disable-next-line no-case-declarations
            const start = inst?.startVal;
            // eslint-disable-next-line no-case-declarations
            const end = inst?.endVal;
            startDate = format(new Date(start), DateUtil.DisplayFormat);
            endDate = format(new Date(end || start), DateUtil.DisplayFormat);
            this.formGroup.controls[this.controlName[0]].setValue(startDate);
            this.formGroup.controls[this.controlName[1]].setValue(endDate);
            this.startDateUpdated.emit(startDate);
            this.endDateUpdated.emit(endDate);
            break;

          case DatePickerType.Date:
            startDate = format(new Date(inst.getVal()), DateUtil.DisplayFormat);
            this.formGroup.controls[this.controlName as string].setValue(
              startDate
            );
            this.startDateUpdated.emit(startDate);
            break;

          case DatePickerType.DOB:
            startDate = format(new Date(inst.getVal()), DateUtil.DobFormat);
            this.formGroup.controls[this.controlName as string].setValue(
              startDate
            );
            this.startDateUpdated.emit(startDate);
            break;
        }
      },
      onSetDate: (event: any, inst: any) => {
        if (event.active === 'end' && event.control) {
          this.mbscInstance?.instance.select();
        }
        //making sure that departureDate and coverEndDate gets marked as touched so that form validation is triggered
        if (this.type == DatePickerType.Range) {
          this.formGroup.controls[this.controlName[0]].markAsTouched();
          this.formGroup.controls[this.controlName[1]].markAsTouched();
        }
      },
      onClose: (event: any, inst: any) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.settings?.onSet(event, inst);
      },
    };
  }
}
